/* LabCharge advertorial behaviour (replaces the Funnelish runtime for this page). */
(function () {
  // Sticky sections with "show after": add .visible once the page is scrolled past N px.
  var showAfter = [].slice.call(document.querySelectorAll('[data-show-after]'));
  function updateShowAfter() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    for (var i = 0; i < showAfter.length; i++) {
      var el = showAfter[i];
      el.classList.toggle('visible', y >= parseInt(el.getAttribute('data-show-after'), 10));
    }
  }
  if (showAfter.length) {
    window.addEventListener('scroll', updateShowAfter, { passive: true });
    window.addEventListener('resize', updateShowAfter);
    updateShowAfter();
  }

  // "View Bundle Offers" sticky button: jump to the bundle section (same instant jump as Funnelish).
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-lc-goto]') : null;
    if (!trigger) return;
    var target = document.querySelector(trigger.getAttribute('data-lc-goto'));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView();
  });

  // Hide the sticky bar while the bundle offers are on screen.
  function setupBundleVisibility() {
    var bundles = document.getElementById('labcharge-bundles');
    if (!bundles || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      document.documentElement.classList.toggle('lc-bundles-visible', entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(bundles);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupBundleVisibility, { once: true });
  } else {
    setupBundleVisibility();
  }
})();
